/* 15 Gün 15 Sürpriz — geri sayım, 10:00 geçişi, etkileşimler, sepete ekleme.
   Tüm kökler [data-asp] taşır: data-sinir (bir sonraki değişim, epoch sn),
   data-simdi (sunucunun gördüğü an), data-test (1 = taslak test saati),
   data-section-id (varsa bölüm Section Rendering API ile tazelenir). */
(() => {
  if (window.__aspYuklendi) return;
  window.__aspYuklendi = true;

  const hareket = () => !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const inceImlec = () => window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const iki = n => String(n).padStart(2, '0');
  const yeniden = (el, sinif) => { el.classList.remove(sinif); void el.offsetWidth; el.classList.add(sinif); };

  /* Şimdi (ms). Canlıda istemci saati; taslak testte sunucunun test anından ilerler. */
  function simdi(kok) {
    if (kok.dataset.test !== '1') return Date.now();
    if (kok._ofset === undefined) kok._ofset = Number(kok.dataset.simdi) * 1000 - Date.now();
    return Date.now() + kok._ofset;
  }

  /* ---------- Geri sayım ve 10:00 geçişi ---------- */
  function tick() {
    document.querySelectorAll('[data-asp]').forEach(kok => {
      const sinir = Number(kok.dataset.sinir);
      if (!sinir) return;
      const k = Math.max(0, Math.floor((sinir * 1000 - simdi(kok)) / 1000));
      const gun = Number(kok.dataset.gun);
      const sonSaat = k > 0 && k <= 3600 && gun >= 0 && gun <= 14;
      kok.classList.toggle('asp-son-saat-var', sonSaat);
      const deger = { h: iki(Math.floor(k / 3600)), m: iki(Math.floor((k % 3600) / 60)), s: iki(k % 60) };
      kok.querySelectorAll('[data-asp-cd]').forEach(el => {
        el.classList.toggle('asp-son-saat', sonSaat);
        for (const a of ['h', 'm', 's']) {
          const b = el.querySelector(`[data-${a}]`);
          if (b && b.textContent !== deger[a]) {
            b.textContent = deger[a];
            if (hareket()) yeniden(b, 'asp-dg');
          }
        }
      });
      if (k === 0) sinirGecti(kok);
    });
  }

  function sinirGecti(kok) {
    if (kok.hasAttribute('data-asp-rozet')) { kok.classList.add('asp-gizli'); return; }
    if (kok.dataset.test === '1') return;          // taslak test saati ilerlemez; tazeleme döngüye girer
    if (!kok.dataset.sectionId) return;
    tazele(kok);
  }

  /* Bölümü sunucudan yeniden ister. Sunucu (ya da önbellek) henüz yeni günü
     görmüyorsa 20 sn arayla en fazla 6 kez dener. */
  async function tazele(kok) {
    if (kok._tazeleniyor) return;
    kok._tazeleniyor = true;
    const eskiSinir = kok.dataset.sinir;
    const tekrarDene = () => {
      kok._deneme = (kok._deneme || 0) + 1;
      if (kok._deneme <= 6) setTimeout(() => { kok._tazeleniyor = false; }, 20000);
    };
    try {
      const url = new URL(window.location.href);
      url.searchParams.set('section_id', kok.dataset.sectionId);
      url.searchParams.set('asp', String(Date.now()));
      const yanit = await fetch(url.toString(), { credentials: 'same-origin' });
      if (!yanit.ok) return tekrarDene();
      const kap = document.createElement('div');
      kap.innerHTML = await yanit.text();
      const yeni = kap.querySelector('[data-asp]');
      if (!yeni) { kok.remove(); return; }         // bant: kampanya bitti
      if (yeni.dataset.sinir === eskiSinir) return tekrarDene();
      kok.replaceWith(yeni);
      baslat(yeni);
      tick();
    } catch (hata) {
      tekrarDene();
    }
  }

  /* ---------- Açılış hareketleri ---------- */
  function yuzdeSay(b) {
    if (b.dataset.aspSayildi) return;
    b.dataset.aspSayildi = '1';
    if (!hareket()) return;
    const hedef = Number(b.dataset.aspSayim);
    if (!hedef) return;
    const yaz = v => { b.textContent = '%' + v.toLocaleString('tr-TR', { maximumFractionDigits: 1 }); };
    const sure = 900;
    let bas = null;
    const adim = t => {
      if (bas === null) bas = t + 350;
      const p = Math.min(1, Math.max(0, (t - bas) / sure));
      const e = 1 - Math.pow(1 - p, 3);
      yaz(p < 1 ? Math.floor(hedef * e) : hedef);
      if (p < 1) requestAnimationFrame(adim);
    };
    requestAnimationFrame(adim);
  }

  function baslat(kok) {
    const sayimlar = kok.querySelectorAll('[data-asp-sayim]');
    if (!sayimlar.length) return;
    if (!('IntersectionObserver' in window)) { sayimlar.forEach(yuzdeSay); return; }
    const gozcu = new IntersectionObserver(girdiler => {
      girdiler.forEach(g => { if (g.isIntersecting) { yuzdeSay(g.target); gozcu.unobserve(g.target); } });
    }, { threshold: 0.6 });
    sayimlar.forEach(b => gozcu.observe(b));
  }

  /* ---------- Etkileşimler (belge düzeyinde; tazelenen bölümde de çalışır) ---------- */
  let egik = null;
  const egikSifirla = el => { ['--rx', '--ry', '--sc'].forEach(p => el.style.removeProperty(p)); };
  document.addEventListener('pointermove', e => {
    const el = e.target.closest ? e.target.closest('[data-asp-egik]') : null;
    if (egik && egik !== el) { egikSifirla(egik); egik = null; }
    if (!el || !inceImlec() || !hareket()) return;
    egik = el;
    const r = el.getBoundingClientRect();
    const x = (e.clientX - r.left) / r.width - 0.5;
    const y = (e.clientY - r.top) / r.height - 0.5;
    el.style.setProperty('--ry', (x * 14).toFixed(2) + 'deg');
    el.style.setProperty('--rx', (-y * 14).toFixed(2) + 'deg');
    el.style.setProperty('--sc', '1.05');
  }, { passive: true });

  function konfeti(btn) {
    if (!hareket()) return;
    const renk = ['#F0B7BC', '#D98C94', '#A94600', '#282928', '#FFF3F3'];
    for (let i = 0; i < 22; i++) {
      const p = document.createElement('span');
      const a = Math.random() * Math.PI * 2;
      const r = 50 + Math.random() * 70;
      p.className = 'asp-konfeti';
      p.style.background = renk[i % renk.length];
      p.style.setProperty('--dx', Math.cos(a) * r + 'px');
      p.style.setProperty('--dy', Math.sin(a) * r - 30 + 'px');
      p.style.setProperty('--r', (Math.random() * 540 - 270) + 'deg');
      btn.appendChild(p);
      setTimeout(() => p.remove(), 1000);
    }
  }

  document.addEventListener('click', e => {
    const kilit = e.target.closest('[data-asp-kilit]');
    if (kilit) {
      const li = kilit.closest('.asp-kutu');
      li.querySelector('.asp-balon')?.remove();
      const balon = document.createElement('span');
      balon.className = 'asp-balon';
      balon.setAttribute('role', 'status');
      balon.innerHTML = `${kilit.dataset.aspKilit}<br>10:00'da açılıyor`;
      li.appendChild(balon);
      setTimeout(() => balon.remove(), 2300);
      if (hareket()) yeniden(li, 'asp-kilitli');
      return;
    }

    if (e.target.closest('[data-asp-bugun]')) {
      const hedef = document.getElementById('asp-gunun');
      if (!hedef) return;
      hedef.scrollIntoView({ behavior: hareket() ? 'smooth' : 'auto', block: 'start' });
      const gorsel = hedef.querySelector('.asp-gorsel');
      if (gorsel) setTimeout(() => yeniden(gorsel, 'asp-vurgu'), hareket() ? 450 : 0);
      return;
    }

    const ton = e.target.closest('[data-asp-ton]');
    if (ton) {
      const bilgi = ton.closest('.asp-bilgi');
      bilgi.querySelectorAll('[data-asp-ton]').forEach(b => b.setAttribute('aria-pressed', String(b === ton)));
      const ad = bilgi.querySelector('[data-asp-ton-ad]');
      if (ad) ad.textContent = ton.dataset.ad;
      const form = bilgi.querySelector('[data-asp-sepet]');
      if (form) {
        form.querySelector('[data-asp-varyant]').value = ton.dataset.aspTon;
        const btn = form.querySelector('button');
        const yazi = btn.querySelector('.asp-yazi');
        if (!btn.dataset.etiket) btn.dataset.etiket = yazi.textContent;
        const var_ = ton.dataset.var === 'true';
        btn.disabled = !var_;
        yazi.textContent = var_ ? btn.dataset.etiket : 'Bu ton tükendi';
      }
      return;
    }

    const ozet = e.target.closest('.asp-sss summary');
    if (ozet && hareket() && typeof ozet.parentElement.animate === 'function') {
      e.preventDefault();
      const d = ozet.parentElement;
      const bas = d.offsetHeight;
      if (!d.open) {
        d.open = true;
        d.animate([{ height: bas + 'px' }, { height: d.offsetHeight + 'px' }], { duration: 300, easing: 'cubic-bezier(.2,.8,.2,1)' });
      } else {
        const a = d.animate([{ height: bas + 'px' }, { height: ozet.offsetHeight + 1 + 'px' }], { duration: 240, easing: 'ease-in' });
        a.onfinish = () => { d.open = false; };
      }
    }
  });

  /* ---------- Sepete ekle: temanın kendi sepet akışı (Eurus xCartHelper) ---------- */
  document.addEventListener('submit', async e => {
    const form = e.target.closest('[data-asp-sepet]');
    if (!form) return;
    const yardimci = window.Alpine && Alpine.store ? Alpine.store('xCartHelper') : null;
    if (!yardimci || typeof yardimci.getSectionsToRender !== 'function') return; // normal form gönderimi
    e.preventDefault();
    const btn = form.querySelector('button');
    const hataEl = form.closest('.asp-bilgi')?.querySelector('[data-asp-hata]');
    btn.classList.add('asp-yukleniyor');
    try {
      if (typeof yardimci.waitForCartUpdate === 'function') await yardimci.waitForCartUpdate();
      const id = Number(form.querySelector('[data-asp-varyant]').value);
      const kok = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      const yanit = await fetch(kok + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity: 1 }], sections: yardimci.getSectionsToRender().map(s => s.id) })
      });
      const veri = await yanit.json();
      if (!yanit.ok || veri.status) {
        if (hataEl) { hataEl.textContent = veri.description || veri.message || 'Ürün sepete eklenemedi. Lütfen tekrar dene.'; hataEl.hidden = false; }
        return;
      }
      if (hataEl) hataEl.hidden = true;
      if (veri.sections) yardimci.reRenderSections(veri.sections);
      document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
      btn.classList.add('asp-eklendi');
      konfeti(btn);
      setTimeout(() => { const mini = Alpine.store('xMiniCart'); if (mini && typeof mini.openCart === 'function') mini.openCart(); }, 650);
      setTimeout(() => btn.classList.remove('asp-eklendi'), 2400);
    } catch (hata) {
      form.submit();
    } finally {
      btn.classList.remove('asp-yukleniyor');
    }
  });

  /* ---------- Başlat ---------- */
  const hepsi = () => { document.querySelectorAll('[data-asp]').forEach(baslat); tick(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hepsi); else hepsi();
  setInterval(tick, 1000);
  document.addEventListener('shopify:section:load', hepsi);
})();
